var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"file-view"},[_c('div',{staticClass:"file-content-view base-file-view-padding"},[_c('div',{staticClass:"file-header-container"},[_c('h1',{staticClass:"file-header"},[_vm._v("Activity feed")])])])])
}]

export { render, staticRenderFns }